import { render, staticRenderFns } from "./SynastryInterpretCard.vue?vue&type=template&id=2dd7b7ba&"
import script from "./SynastryInterpretCard.vue?vue&type=script&lang=js&"
export * from "./SynastryInterpretCard.vue?vue&type=script&lang=js&"
import style0 from "./SynastryInterpretCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dd7b7ba')) {
      api.createRecord('2dd7b7ba', component.options)
    } else {
      api.reload('2dd7b7ba', component.options)
    }
    module.hot.accept("./SynastryInterpretCard.vue?vue&type=template&id=2dd7b7ba&", function () {
      api.rerender('2dd7b7ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/雙人合盤/SynastryInterpretCard.vue"
export default component.exports